<template>
  <div class="navbar">
    <div class="navbar-inner">
      <div class="flex a-center">
        <!-- <img class="h-32" src="@/assets/home/logo@2x.png" alt=""> -->
        <div class="top-menu">
          <div v-for="(i,index) in memu" :key="index">
            <div :class="activeIndex === index?'active':''" @click="$router.push(i.path)"><img v-if="index === 0" style="" class="h-16 mb-4 mr-4" src="@/assets/home/menu_logo@2x.png" alt="">{{ i.title }}</div>

          </div>
        </div>
      </div>
      <div v-if="!$store.state.user.userName">
        <a-button @click="$login.show()">登录</a-button>
        <a-button type="primary" @click="$register.show()">注册</a-button>
      </div>
      <div v-else class="flex a-center fs-12 rig">
        <div class="mr-20">公司预存：<span class="f-c-blue">{{ $store.state.user.balance||'0.00' }}元</span></div>
        <div class="mr-20">今日下单：<span class="f-c-blue">{{ $store.state.user.orderCount }}</span></div>
        <div class="mr-20">
          <a-button v-if="$store.state.user.isAdmin" type="primary" size="small" @click="$router.push('/main/manager/order/recharge')">在线充值</a-button>
          <a-button v-if="$store.state.user.role==0" class="ml-10" type="primary" ghost size="small" @click="$router.push('/main/manager/company-info-management')">企业管理</a-button>
          <a-button v-if="$store.state.user.isAdmin" class="ml-10" type="primary" ghost size="small" @click="$router.push('/main/manager')">企业管理</a-button>
        </div>

        <div>
          <a-dropdown overlay-class-name="header-down">
            <span v-if="$store.state.user.hasCompany" class="pointer" @click="$router.push('/main/manager/personal-info-management')">{{ $store.state.user.userName }}<span v-if="$store.state.user.hasCompany">（{{ $store.state.user.isAdmin?'管理员':'普通员工' }}）</span><a-icon type="down" /></span>
            <span v-else class="pointer">{{ $store.state.user.userName }}<span v-if="$store.state.user.hasCompany">（{{ $store.state.user.isAdmin?'管理员':'普通员工' }}）</span><a-icon type="down" /></span>
            <a-menu slot="overlay" class="w-96   ">

              <a-menu-item>
                <a href="javascript:;" @click="logout">退出</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device'
    ]),
    activeIndex() {
      return this.memu.findIndex(el => this.$route.path.indexOf(el.path) !== -1)
    }
  },
  data() {
    return {
      memu: [
        {
          path: '/main/index',
          title: '首页'
        },
        {
          path: '/main/send',
          title: '在线寄件'

        },
        {
          path: '/main/search',
          title: '订单监控'
          // children: [{
          //   path: '/trace',
          //   title: '轨迹查询'
          // }
          // ]
        },
        {
          path: '/main/address',
          title: '地址管理'
        },
        {
          path: '/main/statistics',
          title: '寄件统计'
        }
      ]
    }
  },
  watch: {
    $route() {
    }
  },
  created() {
    //  const route = this.$route
    //   const { meta, path } = route
  },
  methods: {

    async logout() {
      this.$removeToken()
      sessionStorage.clear()
      localStorage.clear()
      window.location.href = '/'
      // await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    }
  }
}
</script>
<style lang="scss" >
.header-down{
      display: flex;
      flex-direction: row;
    justify-content: flex-end;
}
</style>
<style lang="scss" scoped>
@import '@/styles/common.scss';
.navbar {
  height: 48px;
  overflow: hidden;
  position: relative;
  background: #001529;
  color: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  display: flex;
  align-items: center;
  flex-wrap:nowrap;
  .navbar-inner{
    width: 1200px;
    display: flex;
    flex-wrap:nowrap;
    align-items: center;
    justify-content: space-between;
    margin:0 auto;

  }
  .rig{
    min-width:530px;
  }
  .top-menu{
    // margin-left: 40px;
    height: 60px;
    @extend .flex ;
    @extend .a-center;
    >div{
      height: 60px;
      line-height: 60px;
      width: 96px;
      text-align: center;
      cursor: pointer;
      font-size: 16px;
      color: #fff;
      // font-weight: bold;
      margin-right: 20px;;
    }
    .active{
      @extend .f-c-blue;
      position: relative;
      background: #1890FF;
      color: #fff;
      text-align: center;
      // &:after{
      //   content: '';
      //   position: absolute;
      //   bottom: 0px;
      //   left: 0;
      //   height: 1px;
      //   background: #1890FF;
      //   width: 100%;
      // }
    }
  }
}
</style>
